import { Component, OnInit, Input } from '@angular/core';
import { StepService } from '../_servizi/step.service';

@Component({
  selector: 'app-riepilogo-prenotazione',
  templateUrl: './riepilogo-prenotazione.component.html',
  styleUrls: ['./riepilogo-prenotazione.component.css']
})
export class RiepilogoPrenotazioneComponent implements OnInit {

  @Input() visita: any;
  @Input() carrello: any;
  @Input() cantinaSC: any;

  get totale(): number {
    let totale = this.stepService.getTotale();
    if (this.cantinaSC && this.visita.supplementoattivo === '1') {
      totale = totale + (parseInt(this.carrello.nadulti) * parseFloat(this.visita.supplemento))
    }
    return totale;
  }

  get supplemento(): number {
    return parseInt(this.carrello.nadulti) * parseFloat(this.visita.supplemento)
  }

  constructor(
    private stepService: StepService
  ) { }

  ngOnInit(): void {
  }

}
